import * as React from 'react';

export function Support16() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#737A8E"
        fillRule="evenodd"
        d="M8 2a4 4 0 00-4 4 1 1 0 011 1v3a1 1 0 01-1 1H2a1 1 0 01-1-1V7a1 1 0 011-1 6 6 0 1112 0 1 1 0 011 1v3a1 1 0 01-1 1h-.1A5.002 5.002 0 019 15H8a2 2 0 111.993-2.168 3.008 3.008 0 001.841-1.846A1 1 0 0111 10V7a1 1 0 011-1 4 4 0 00-4-4z"
        clipRule="evenodd"
      />
    </svg>
  );
}
